import React from 'react';
import { useGrid } from '../hook';

const PageIndicator = () => {
  const {
    page,
    perPage,
    query
  } = useGrid();
  const pageIndex = page * perPage - perPage;
  const isLastPage = pageIndex + perPage >= query.totalCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-page-indicator"
  }, pageIndex + 1, " - ", pageIndex + (isLastPage ? query.totalCount % perPage : perPage), " of ", query.totalCount);
};

export default PageIndicator;